module.exports = __webpack_public_path__ + "static/tyr-symbol-DND3_FnP-53abbd30f257ffbd11776a9bca2c409b.webp";